<template>
    <div class="container" v-loading="tableing">
        <div class="header">
            <el-button class="exit" size="mini" @click="exit()"> 退出 </el-button>
        </div>
        <div class="main">
            <div class="exmaConter">
                <p class="exmaConter-title">{{paperName}}</p>
                <p class="exmaConter-one">{{partThe}}</p>
            </div>
            <div class="examImg"></div>
            <div class="goExamBox">
                <p v-if="$route.query.userSignId">
                    填报时间：{{$route.query.examStartDateVal}} - {{$route.query.examEndDateVal}}&nbsp;&nbsp;
                    <!-- 考试时长：<span v-if="$route.query.examMin!=-1">{{$route.query.examMin}}分钟</span><span v-else>不限时</span> -->
                </p>
                <el-button :class="['upSub',clickIsYes?'':'disabledStyle']" @click="lastQuestion()"> {{veinQuest[rNGet].myExamList.goBtu||'开始填报'}} </el-button>
            </div>
        </div>
    
        <audio ref="dearStudent" :src="tockUrl" @ended="endTockUrl9" v-show="false"></audio>
        <audio ref="dearStudent1" id="dearStudent1" :src="tockUrl1" v-show="false"></audio>
    </div>
</template>
<script>
import { getDateNow } from '../../lib/youxunAPI';
    export default {
        name:"chooseOrg",
        data() {
            return {
                tableing:false,
                tockUrl:'',
                tockUrl91:require('../../../static/music/ninthGrade91.aac'),
                tockUrl92:require('../../../static/music/ninthGrade92.aac'),
                tockUrl1:require('../../../static/music/92-1-0.aac'),
                paperName:'',
                partThe:'',
                clickIsYes:true,
                rimsTimer:'',
            }
        },
        components:{},
        watch: {},
        computed:{},
        created(){},
        beforeDestroy() {
            this.rimsTimer && clearInterval(this.rimsTimer)
        },
        computed:{
            rNGet: function () {
                return localStorage.getItem('roadName')?localStorage.getItem('roadName'):'guoyin'
            }
        },
        mounted(){
            this.$nextTick(()=>{
                let that = this
                setTimeout(function(){
                    that.paperName = that.$route.query.paperName
                    if(that.paperName.trim()=="九年级音乐网络测试卷一".trim()){
                        that.tockUrl = that.tockUrl91
                    }
                    if(that.paperName.trim()=="九年级音乐网络测试卷二".trim()){
                        that.tockUrl = that.tockUrl92
                    }
                    setTimeout(function () {
                        that.$refs.dearStudent.play()
                    },10)
                },0)
                if(sessionStorage.getItem('orgId')){//测评
                    that.partThe = ''
                }
                if(that.$route.query.userSignId){//考级
                    that.rimsClickType()
                }
            })
        },
        methods:{
            endTockUrl9(){
                let that = this
                setTimeout(function () {
                    that.$refs.dearStudent1.play()
                },10)
            },
            exit(){
                this.$confirm('请问是否退出？','确认信息',{
                    confirmButtonText:'退出',
                    cancelButtonText:'否',
                })
                .then(()=>{
                    this.$router.push({
                        path: '/myExamList'
                    })
                })
                .catch((action)=>{})
            },
            // 查看是否到考试时间
            timeToCompare(a=false,callback){
                let that = this
                if(!that.$route.query.userSignId){//测评
                    return callback(true);
                }
                if(that.$route.query.bohuiChongchuan==0&&that.$route.query.examStatus&&that.$route.query.examStatus==1){
                    if(a)that.$message('填报已完成');
                    return callback(false);
                }
                that.judgeTime(a,function(foo){
                    return callback(foo)
                })
            },
            judgeTime(a,callback){
                let that = this
                let temp;
                getDateNow(function(response){
                    if(response.data&&response.data.code == 0){
                        if(that.$route.query.examStartDate<=response.data.data.sysTime){
                            if(that.$route.query.examEndDate<=response.data.data.sysTime){
                                if(a)that.$message('填报已结束');
                                temp = false;
                            }else{
                                temp = true;
                            }
                        }else{
                            if(a)that.$message('填报暂未开始');
                            temp = false;
                        }
                        return callback(temp)
                    }else{
                        let poorTime = window.localStorage.getItem('poorVal')
                        let timestamp2 = Date.parse(new Date());
                        if(Number(poorTime)>=0){timestamp2 = Number(timestamp2) + Number(poorTime)}
                        else{timestamp2 = Number(timestamp2) - Number(Math.abs(poorTime))}
                        if(that.$route.query.examStartDate<=timestamp2){
                            if(that.$route.query.examEndDate<=timestamp2){
                                if(a)that.$message('填报已结束');
                                temp = false;
                            }else{
                                temp = true;
                            }
                        }else{
                            if(a)that.$message('填报暂未开始');
                            temp = false;
                        }
                        return callback(temp)
                    }
                })
            },
            lastQuestion(){
                let that = this
                that.$nextTick(()=>{
                    that.timeToCompare(true,function(action){
                        if(action){
                            that.$router.push({
                                path: '/problem',
                                query: {
                                    bId:that.$route.query.bId,
                                    userSignId:that.$route.query.userSignId,
                                    ticketNum:that.$route.query.ticketNum,
                                    idName:that.$route.query.idName,
                                    idCardNo:that.$route.query.idCardNo,
                                    paperName:that.$route.query.paperName,
                                    youXunExamNum:that.$route.query.youXunExamNum,
                                    personNum:that.$route.query.personNum,
                                    examMin:that.$route.query.examMin,
                                    examStartDate:that.$route.query.examStartDate,
                                    examEndDate:that.$route.query.examEndDate,
                                    reviewType:that.$route.query.reviewType,
                                    bohuiChongchuan:that.$route.query.bohuiChongchuan,
                                }
                            })
                        }
                    })
                })
            },
            rimsClickType(){
                let that = this
                that.rimsTimer = setInterval((function target(){
                    that.timeToCompare(false,function(action){
                        that.clickIsYes = action
                    })
                    return target
                })(),30000)
            }
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid #EDEEED;
        .exit{
            background-color: #31C4FE;
            border: none;
            font-size: 15px;
            width: 74px;
            height: 32px;
            color: #fff;
            position: absolute;
            top: 15px;
            right: 3%;
            img{
                height: 10px;
            }
        }
    }
    .main{
        position: absolute;
        top: 120px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        .exmaConter{
            height: 10%;
            width: 100%;
            position: relative;
            .exmaConter-title{
                font-size: 30px;
                font-weight: bold;
            }
            .exmaConter-one{
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                font-size: 17px;
            }
        }
        .examImg{
            height: 70%;
            width: 100%;
            background-image: url('../../../static/images/PIC.png');
            background-position: 50% 51%;
            background-size: 105% auto;
            background-repeat: no-repeat;
        }
        .goExamBox{
            height: 20%;
            width: 100%;
            position: relative;
            .upSub{
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                height: 42px;
                width: 35%;
                background:#1CC966;
                color: #FFF;
                border-radius: 3px;
                font-size: 17px;
            }
        }
    }
    .disabledStyle{
        color: #fff !important;
        background-color: #b3e19d !important;
        border-color: #b3e19d !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/myExamList/examination.vue